import { USERS } from "@constants/routes";

const SECURITY = [{ route: USERS, name: "Users" }];

export default SECURITY;
